import type { IconSvgObject } from './types';

const InsertRowUpIcon: IconSvgObject = [
  ["path", { d: "M18 2.8125C18.8888 3.01415 19.5638 3.34564 20.1088 3.89059C21.5 5.28184 21.5 7.52101 21.5 11.9994C21.5 16.4777 21.5 18.7169 20.1088 20.1081C18.7175 21.4993 16.4783 21.4993 12 21.4993C7.52166 21.4993 5.28249 21.4993 3.89124 20.1081C2.5 18.7169 2.5 16.4777 2.5 11.9993C2.5 7.52101 2.5 5.28184 3.89124 3.89059C4.4362 3.34564 5.11125 3.01415 6.00001 2.8125", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M9 5.5L12 2.5L15 5.5M12 3.5V10.5", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2.5 15H21.5", stroke: "currentColor", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M8.5 21.5L8.5 15M15.5 21.5L15.5 15", stroke: "currentColor", strokeWidth: "1.5", key: "3" }]
];

export default InsertRowUpIcon;
